import { cssPolices, parNomDeFichier } from './polices';

/**
 * Déclare les polices des documents à l'application.
 *
 * <p>Le navigateur ne télécharge un fichier que lorsqu'une page l'emploie :
 * déclarer les seize polices ne coûte rien tant qu'on ne les affiche pas.
 */
const FICHIERS = parNomDeFichier(
  import.meta.glob('../assets/polices/*.woff2', { eager: true, query: '?url', import: 'default' }),
);

export function declarePolices() {
  if (typeof document === 'undefined' || document.getElementById('polices-documents')) return;
  const style = document.createElement('style');
  style.id = 'polices-documents';
  style.textContent = cssPolices(FICHIERS);
  document.head.appendChild(style);
}
